import { FC } from 'react';

import { SvgIconProps } from 'types/styles';
import { SvgIcon } from 'ui/SvgIcon';

export const PasswordLockIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M12 2.5C9.243 2.5 7 4.743 7 7.5V10.5H6C4.897 10.5 4 11.397 4 12.5V20.5C4 21.603 4.897 22.5 6 22.5H18C19.103 22.5 20 21.603 20 20.5V12.5C20 11.397 19.103 10.5 18 10.5H17V7.5C17 4.743 14.757 2.5 12 2.5ZM18 12.5L18.002 20.5H6V12.5H18ZM9 10.5V7.5C9 5.846 10.346 4.5 12 4.5C13.654 4.5 15 5.846 15 7.5V10.5H9Z"
      fill="#323B55"
      fillOpacity="0.1"
    />
  </SvgIcon>
);
